import { DateTime } from 'luxon';
import cloneDateTime from './cloneDateTime';
import isSameDay from './isSameDay';

export default function isPreviousDay(a, b) {
  if (!(a instanceof DateTime) || !(b instanceof DateTime)) return false;
  
  
  const dayBefore = cloneDateTime(a).minus({ days: 1 });
  return isSameDay(dayBefore, b);
}
